export function formatFileSize(bytes: number): string {
  if (!bytes) return '0 B';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function fileIcon(name: string): string {
  const ext = name.split('.').pop()?.toLowerCase() ?? '';
  if (ext === 'pdf') return 'ri-file-pdf-2-line';
  if (ext === 'doc' || ext === 'docx') return 'ri-file-word-2-line';
  if (ext === 'xls' || ext === 'xlsx' || ext === 'csv') {
    return 'ri-file-excel-2-line';
  }
  if (ext === 'ppt' || ext === 'pptx') return 'ri-file-ppt-2-line';
  if (['zip', 'rar', '7z', 'tar', 'gz'].includes(ext)) {
    return 'ri-file-zip-line';
  }
  if (ext === 'txt' || ext === 'md') return 'ri-file-text-line';
  if (['mp3', 'wav', 'ogg', 'flac'].includes(ext)) {
    return 'ri-file-music-line';
  }
  if (['mp4', 'mov', 'avi', 'mkv'].includes(ext)) {
    return 'ri-file-video-line';
  }
  if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) {
    return 'ri-image-line';
  }
  return 'ri-file-2-line';
}